<!--
 Copyright (c) Qwoach LLC 2024. All rights reserved.
 Unauthorized copying of this file, via any medium is strictly prohibited
 Proprietary and confidential
 Created by Artem Bogush <artem@qwoach.com> on 22/11/2024
-->

<template>

	<button class="el-button" :disabled="loading" :class="[typeClassComputed, sizeClassComputed, {'is-loading': loading}]">
		<div>
			<div v-if="loading" class="fontello icon-spin5 mr-2"/>
			<slot>Button</slot>
		</div>
	</button>

</template>

<script>

import BaseComponent from "@/core/components/BaseComponent.vue";

export default {
	name: "ElButtonLight",
	extends: BaseComponent,

	props: {
		type: String,
		size: String,
		loading: Boolean,
	},

	computed: {
		typeClassComputed() {
			switch (this.type) {
				case 'primary':
					return 'el-button--primary'
				case 'success':
					return 'el-button--success'
				case 'warning':
					return 'el-button--warning'
				case 'danger':
					return 'el-button--danger'
				case 'info':
					return 'el-button--info'
				default:
					return ''
			}
		},

		sizeClassComputed() {
			switch (this.size) {
				case 'medium':
					return 'el-button--medium'
				case 'small':
					return 'el-button--small'
				case 'mini':
					return 'el-button--mini'
				default:
					return ''
			}
		},
	},
}
</script>

<style lang="scss">

.el-button {
	.bounce1, .bounce2, .bounce3 {
		background-color: white;
	}

	&.is-loading {
		pointer-events: none;
		position: relative;
	}
}

</style>
